/** Zoom provider — live class via validated external link (https). */
import { makeExternalProvider } from "./external";

export const zoomProvider = makeExternalProvider({
  id: "zoom",
  name: "Zoom",
  description: "Clase en vivo por enlace externo de Zoom (https validado).",
  requiresCredentials: false,
  urlPlaceholder: "https://zoom.us/j/…",
});
